import { render, staticRenderFns } from "./Silent.vue?vue&type=template&id=5be389e7&"
import script from "./Silent.ts?vue&type=script&lang=ts&"
export * from "./Silent.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports